export type Floorplan3DMetricName =
  | "texture_load"
  | "texture_load_failed"
  | "material_assignment"
  | "product_replacement"
  | "product_render_mode"
  | "symbol_3d_asset_load"
  | "symbol_3d_asset_fallback"
  | "long_task_after_material_assignment"
  | "ai_render_manifest_created"
  | "ai_render_completed"
  | "ai_render_payload_too_large"
  | "ai_video_completed";

export function trackFloorplan3DMetric(
  name: Floorplan3DMetricName,
  payload: Record<string, unknown> = {},
) {
  const detail = {
    name,
    payload,
    timestamp: Date.now(),
  };
  window.dispatchEvent(new CustomEvent("floorplanner:3d-metric", { detail }));
  if (process.env.NODE_ENV !== "production") {
    console.debug("[floorplanner:3d-metric]", detail);
  }
}

export function monitorLongTaskAfterMaterialAssignment() {
  const start = performance.now();
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      const elapsed = performance.now() - start;
      if (elapsed > 120) {
        trackFloorplan3DMetric("long_task_after_material_assignment", {
          elapsed,
        });
      }
    });
  });
}
